import { americanToDecimal } from "@/utils/calculators/odds-utils";
import { getEdgeSupportingLiquidity, getWhaleDemandFromOpposite, recomputeEdgePercent, type BookData, type MarketOpportunity, type PeerOdds, type Side } from "@/lib/whale-watch/whale-watch-shared";
import { practiceOdds } from "./youtube-kalshi";

export const YOUTUBE_KALSHI_WHALES = {
  videoId: "IA81WFwepFY",
  title: "Kalshi Strategy: Copy The Whales, Don't Gamble (Most People Get This Wrong)",
  slug: "kalshi-whales",
  path: "/learning-center/watch/kalshi-whales",
  flag: "youtube_kalshi_whales_walkthrough_v1",
  exposure: "youtube_walkthrough_experiment_entered",
  version: "kalshi_whales_walkthrough_v1",
  tool: "/whale-watch",
} as const;

function postedYesMoney(yesOdds: number, money: number): BookData {
  const odds_decimal = americanToDecimal(-yesOdds);
  const liquidity = money / (odds_decimal - 1);
  return { odds_american: -yesOdds, odds_decimal, liquidity, total_liquidity: liquidity, actual_money_at_risk: money, order_book: [{ odds: odds_decimal, liquidity }] };
}

const oppositeBooks = { polymarket: postedYesMoney(-122, 31300), novig: postedYesMoney(-121, 100) };
const price = 54;
const contracts = 2037;
const capacity = contracts * price / 100;
const play: Side<PeerOdds> = {
  name: "Yes", line: 0, side: "yes", total_liquidity: capacity, actual_money_at_risk: 0, pinnacle_limit: 0,
  books: { kalshi: { odds_american: practiceOdds(price), odds_decimal: 100 / price, liquidity: capacity, total_liquidity: capacity, actual_money_at_risk: 0 } },
  peers: [{ book: "kalshi", odds_american: practiceOdds(price), odds_decimal: 100 / price, limit: capacity }],
  best_odds: practiceOdds(price), best_book: "kalshi", edge_percent: recomputeEdgePercent(oppositeBooks, practiceOdds(price)), demand: getWhaleDemandFromOpposite(oppositeBooks),
};
const oppositeLiquidity = Object.values(oppositeBooks).reduce((sum, book) => sum + book.liquidity, 0);
const opposite: Side<PeerOdds> = {
  name: "No", line: 0, side: "no", total_liquidity: oppositeLiquidity, actual_money_at_risk: 31400, pinnacle_limit: 0,
  books: oppositeBooks, peers: [], best_odds: 122, best_book: "polymarket", demand: getWhaleDemandFromOpposite(play.books),
};

export const SOCCER_PRACTICE_WHALE: MarketOpportunity<PeerOdds> = {
  id: "practice-germany-ivory-coast-btts", event_id: "practice-germany-ivory-coast", event: "Ivory Coast vs Germany",
  event_start: "2026-06-20T20:00:00Z", updated_at: "2026-06-17T16:00:00Z",
  home_team: "Germany", away_team: "Ivory Coast", league: "FIFA World Cup", sport: "Soccer", market_type: "both_teams_to_score",
  market: { market: "Both Teams To Score", line: 0, sides: [play, opposite], market_arity: 2, total_liquidity: capacity + oppositeLiquidity, pinnacle_limit: 0, edge_supporting_liquidity: getEdgeSupportingLiquidity(oppositeBooks, play.best_odds), same_side_conviction_liquidity: 31400 },
};

export const SOCCER_WHALE_TICKET = {
  id: SOCCER_PRACTICE_WHALE.id, game: SOCCER_PRACTICE_WHALE.event, outcome: "Both teams to score · Yes",
  kind: "Both teams to score" as const, price, contracts, category: "Soccer", slug: "germany-ivory-coast-btts",
  settlement: "Yes pays $1 per contract if both teams score at least once during regulation time, including stoppage time. Extra time and penalties do not count. Otherwise Yes pays $0.",
};

export const WHALE_LESSONS = [
  { label: "Find the footprint", title: "The whale dollars are your starting point.", chapter: 339, instruction: "Whale Watch is sorted by whale dollars. Open the Germany–Ivory Coast example to see the reference orders behind Yes: both teams to score." },
  { label: "Read the context", title: "Size. Persistence. Timing.", chapter: 275, instruction: "The Whale Bets bars show the exchange and price behind the signal. Read them alongside the video's three checks before deciding what to do." },
  { label: "Check the price", title: "Same match. Same outcome. Your price.", chapter: 455, instruction: "The Play shows where to buy. Match Yes: both teams to score, compare the current price, and use the glowing Kalshi button to open a practice ticket." },
] as const;
